import { CSSProperties } from "react";

export const XVictoryPointSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      style={style}
      width={width}
      height={width}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 0.64C12.3 0.64 10.6667 0.306667 9.99999 0.14C8.49999 0.639985 8.49999 2.14001 7 3.14001C5.50001 4.14001 2 4.14001 0.999985 5.64001C-2.93255e-05 7.14001 2 9.14001 1.5 10.14C1 11.14 0 10.14 0 11.64C0 13.14 0.999985 12.64 0.999985 15.14C0.999985 17.64 -1.46627e-05 17.64 0.499985 19.14C0.999985 20.64 3.49999 20.64 3.99999 21.64C4.49999 22.64 2.99999 23.64 4.99999 25.14C6.99999 26.64 6.99999 25.14 8.49999 25.64C9.99999 26.14 9.49999 28.14 11.5 28.64C13.5 29.14 15.5 27.64 18.5 27.64C21.5 27.64 22.5 27.64 25 25.64C27.5 23.64 26.5 21.14 27 19.64C27.5 18.14 29 18.14 29 16.14C29 14.14 28 14.64 28 13.14C28 11.64 29 10.64 28.5 9.14001C28 7.64001 27 8.14001 26 7.14001C25 6.14001 25.5 4.14001 24.5 3.14001C23.5 2.14001 21.5 3.14001 20.5 2.14001C19.5 1.14001 18.5 0.64 17 0.14C15.5 -0.36 15 0.64 13.5 0.64Z"
        fill="#F4EAE1"
      />
      <g filter="url(#filter0_d_219_417)">
        <circle
          cx="14.5"
          cy="14.5"
          r="11.5"
          fill="url(#paint0_radial_219_417)"
        />
      </g>
      <g filter="url(#filter1_d_219_417)">
        <circle cx="21" cy="22" r="4" fill="url(#paint1_radial_219_417)" />
      </g>
      <g filter="url(#filter2_d_219_417)">
        <circle cx="5" cy="8" r="2" fill="url(#paint2_radial_219_417)" />
      </g>
      <defs>
        <filter
          id="filter0_d_219_417"
          x="2"
          y="2"
          width="25"
          height="25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_219_417"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_219_417"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_219_417"
          x="15"
          y="16"
          width="12"
          height="12"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_219_417"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.984314 0 0 0 0 0.878431 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_219_417"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_219_417"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_219_417"
          x="1"
          y="4"
          width="8"
          height="8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_219_417"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.984314 0 0 0 0 0.878431 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_219_417"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_219_417"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_219_417"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16 14) rotate(60.9454) scale(10.2956 19.9962)"
        >
          <stop stopColor="#B3781B" />
          <stop offset="0.645833" stopColor="#E7B03D" />
          <stop offset="1" stopColor="#FFEC8B" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_219_417"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.1739 21.8261) rotate(56.3099) scale(3.76231)"
        >
          <stop stopColor="#F3AF44" />
          <stop offset="1" stopColor="#FFEC8B" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_219_417"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.08696 7.91304) rotate(56.3099) scale(1.88116)"
        >
          <stop stopColor="#F3AF44" />
          <stop offset="1" stopColor="#FFEC8B" />
        </radialGradient>
      </defs>
    </svg>
  );
};
